import React, { useEffect } from "react";

import { Button } from "/component/base";
import { MyAccountComplete } from "/component/base/Icon";
import EmptyStateCta from "/component/partial/EmptyStateCta";
import { useSignUpProvider } from "/component/provider/SignUpProvider";
import { SignUpFormType } from "/constant/signUp.constant";
import { useAuth, useTranslation } from "/hook";
import { layout } from "/styles";

import { FormContentContainer } from "../SignUpForms.styles";

const AccountCreated = () => {
  const { setCurrentForm } = useSignUpProvider();
  const { t } = useTranslation("form-signUp");
  const { loginNoMFA } = useAuth();

  const continueForm = () => {
    loginNoMFA(`${window.location.origin}/signup?form=${SignUpFormType.PhoneVerification}`);
  };

  useEffect(() => {
    setCurrentForm(SignUpFormType.AccountCreated);
  }, []);

  return (
    <FormContentContainer>
      <EmptyStateCta
        title={t("accountCreated.title")}
        subtitle={
          <div css={[layout.spacedChildrenVertical("standard"), layout.marginVertical("standard")]}>
            {t("accountCreated.subtitle")}
            <br />
            {t("accountCreated.subtitle2")}
          </div>
        }
        icon={<MyAccountComplete size={80} color="brandPrimary" />}
      />

      <FormContentContainer.ButtonGroup>
        <Button onClick={continueForm} variant="primary">
          {t("accountCreated.signIn")}
        </Button>
      </FormContentContainer.ButtonGroup>
    </FormContentContainer>
  );
};

export default AccountCreated;
